<div
    style="display: flex;align-items: flex-start;flex-wrap: nowrap;align-content: center;justify-content: space-between;">
    <h1 matDialogTitle>Search for Customer</h1>
    <button mat-icon-button (click)="close()">
        <mat-icon>close</mat-icon>
    </button>
</div>
<mat-dialog-content style="overflow: hidden;">
    <optsol-ngx-data-table-with-search-criteria [tableConfigRequest]="customersTableConfigRequest"
        [tableDataRequest]="customersTableDataRequest"
        [searchCriteriaConfigRequest]="customersSearchCriteriaConfigRequest" [(selectedKeys)]="selectedKeys"
        (actionButtonClicked)="actionButtonClicked($event)">
    </optsol-ngx-data-table-with-search-criteria>
</mat-dialog-content>
